<template lang="">
  <v-app>
    <!-- <v-parallax :src="spaceBackground"></v-parallax> -->
    <v-container
      class="ma-0"
      :style="`
        position: absolute;
        background-image: radial-gradient(rgba(179, 130, 200, 0.1), rgba(142, 68, 173, 0.23), rgba(0, 0, 0, 0.82)), url(${spaceBackground});
        background-size: cover;
        height: 100%;
        overflow: hidden;
      `"
      fluid
    >
      <div v-if="isElectron" class="d-flex">
        <app-bar />
      </div>
      <v-main>
        <router-view />
      </v-main>
      <div
        v-for="(item, index) in 30"
        :key="index"
        class="circle-container"
      >
        <div class="circle" />
      </div>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'VIndex',
  components: {
    // login: () => import('./pages/Login'),
    // settings: () => import('./pages/Settings'),
    appBar: () => import('./components/AppBar'),
  },
  data() {
    return {
      spaceBackground: require('./../../assets/lock.jpg'),
    }
  },
  computed: {
    isElectron() {
      return process && process.versions && process.versions.electron
    },
  },
  watch: {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
.circle-container {
  $particleNum: 200;
  $particleColor: hsl(180, 100%, 80%);

  position: absolute;
  transform: translateY(-10vh);
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  .circle {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    mix-blend-mode: screen;
    background-image: radial-gradient(hsl(192, 68%, 69%),
        hsl(192, 73%, 75%) 10%,
        hsla(180, 100%, 80%, 0) 56%);

    animation: fadein-frames 200ms infinite, scale-frames 2s infinite;

    @keyframes fade-frames {
      0% {
        opacity: 1;
      }

      50% {
        opacity: 0.7;
      }

      100% {
        opacity: 1;
      }
    }

    @keyframes scale-frames {
      0% {
        transform: scale3d(0.4, 0.4, 1);
      }

      50% {
        transform: scale3d(2.2, 2.2, 1);
      }

      100% {
        transform: scale3d(0.4, 0.4, 1);
      }
    }
  }

  $particleBaseSize: 8;

  @for $i from 1 through $particleNum {
    &:nth-child(#{$i}) {
      $circleSize: random($particleBaseSize);
      width: $circleSize + px;
      height: $circleSize + px;

      $startPositionY: random(10) + 100;
      $framesName: "move-frames-" + $i;
      $moveDuration: 28000 + random(9000) + ms;

      animation-name: #{$framesName};
      animation-duration: $moveDuration;
      animation-delay: random(37000) + ms;

      @keyframes #{$framesName} {
        from {
          transform: translate3d(#{random(100) + vw},
            #{$startPositionY + vh},
            0);
        }

        to {
          transform: translate3d(#{random(100) + vw},
            #{- $startPositionY - random(30) + vh},
            0);
        }
      }

      .circle {
        animation-delay: random(4000) + ms;
      }
    }
  }
}
</style>
